import { ProductCard } from './ProductCard';
import { Package } from 'lucide-react';
import '../accessoriesStyles/product-grid.css';

export function ProductGrid({ products, onQuickAdd, onViewDetails }) {
  if (products.length === 0) {
    return (
      <div className="product-grid-empty">
        <Package className="product-grid-empty-icon" />
        <h3 className="product-grid-empty-title">
          No products found
        </h3>
        <p className="product-grid-empty-description">
          Try adjusting your filters to find what you're looking for
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="product-grid-header">
        <p className="product-grid-count">
          Showing <span className="product-grid-count-number">{products.length}</span> products
        </p>
      </div>
      <div className="product-grid">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onQuickAdd={onQuickAdd}
            onViewDetails={onViewDetails}
          />
        ))}
      </div>
    </div>
  );
}
